module.exports = __webpack_public_path__ + "static/hmd_stemma-a4958b753ecb80ee65ed3bdbd230f9f8.svg";